import { render, staticRenderFns } from "./ActionsDocumentCollaborateur.vue?vue&type=template&id=526022ef&"
import script from "./ActionsDocumentCollaborateur.vue?vue&type=script&lang=js&"
export * from "./ActionsDocumentCollaborateur.vue?vue&type=script&lang=js&"
import style0 from "./ActionsDocumentCollaborateur.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports